"use strict";
/**
 * @module kung-fu/components
 * @description A collection of vanilla JavaScript components for enhancing HTML elements
 *
 * This library provides several utilities for common UI patterns:
 * - Audio player with playlist support
 * - Automatic list style type rotation for nested lists
 * - Image to figure conversion for better semantics
 *
 * @example
 * // Import all components
 * import * as components from '@kung-fu/components';
 *
 * // Use the components
 * components.createAudioPlayer('audio-container', 'default.mp3');
 * components.rotateListStyleType();
 * components.wrapImageWithFigure();
 *
 * @example
 * // Import specific components
 * import { createAudioPlayer, wrapImageWithFigure } from '@kung-fu/components';
 *
 * // Use the components
 * createAudioPlayer('audio-container');
 * wrapImageWithFigure('.content-image');
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./audio"), exports);
__exportStar(require("./bullets"), exports);
__exportStar(require("./figure"), exports);
//# sourceMappingURL=index.js.map